@if (badgeEvent()) {
    <div
        class="absolute inset-0 bg-gradient-to-b from-black/75 via-black/100 to-black/100"
        style="z-index: 30000"
        animate.enter="dc-anim-fade-in"
        animate.leave="dc-anim-fade-out"
        [style.--dc-anim-duration.ms]="250"
        (click)="$event.stopPropagation()"></div>

    <div
        class="absolute inset-0 flex items-center justify-center py-12 text-center portrait:flex-col portrait:px-6 landscape:flex-row landscape:px-12"
        style="z-index: 30001"
        animate.enter="dc-anim-fade-in"
        animate.leave="dc-anim-fade-out"
        [style.--dc-anim-duration.ms]="350"
        (click)="$event.stopPropagation()">
        <div
            class="flex w-full items-end justify-center overflow-hidden portrait:mb-8 landscape:mr-8"
            [class]="
                badgeEvent().profile_badge.lottie_url
                    ? 'h-full portrait:max-h-[40%] portrait:max-w-[20rem] landscape:max-h-[70%] landscape:max-w-[18rem]'
                    : 'max-w-[14rem]'
            ">
            @if (badgeEvent().profile_badge.lottie_url) {
                @if (overlayLottieData()) {
                    <dotlottie-webworker
                        [autoplay]="true"
                        class="flex h-full w-full items-end"
                        canvasClass="h-full w-full"
                        backgroundColor="transparent"
                        [loop]="false"
                        [src]="overlayLottieData()"
                        [useFrameInterpolation]="false"
                        workerId="local-end-screen-lottie"></dotlottie-webworker>
                }
            } @else {
                <img class="h-full w-full" [src]="badgeEvent().profile_badge.icon_url" />
            }
        </div>

        <div class="flex flex-col items-center justify-center">
            <div dcTypography="bulevar-40" class="mt-2 max-w-md text-wire-white-fixed">
                @if (badgeEvent().title) {
                    <div>{{ badgeEvent().title }}</div>
                } @else {
                    <div [translate]="'BADGE_UNLOCKED_EXCLAM'" i18n="@@BADGE_UNLOCKED_EXCLAM">Badge unlocked!</div>
                }
            </div>

            @if (overlayDescription()) {
                <div dcTypography="geist-16-medium" class="mt-4 max-w-md text-wire-white-fixed">
                    {{ overlayDescription() }}
                </div>
            }

            @if (overlayPlayerNames()) {
                <div class="mt-8 flex max-w-md flex-col items-center gap-1 text-center text-wire-white-fixed">
                    <div dcTypography="geist-16-semibold" [translate]="'CONGRATULATIONS'" i18n="@@CONGRATULATIONS">
                        Congratulations!
                    </div>
                    <div dcTypography="geist-16">
                        {{ overlayPlayerNames() }}
                    </div>
                </div>
            }

            @if (showOverlayProfileButton()) {
                <button
                    type="button"
                    class="mt-6 w-full max-w-sm"
                    dcButton
                    dcBgColor="oche-orange"
                    (click)="equipBadge()">
                    <div [translate]="'EQUIP_BADGE'" i18n="@@EQUIP_BADGE">Equip badge</div>
                </button>
            }

            @if (!badgeEvent().auto_hide_after_ms) {
                <button
                    type="button"
                    class="mt-3 w-full max-w-sm"
                    dcButton
                    variant="outline"
                    dcBgColor="oche-orange"
                    (click)="dismissOverlay()">
                    <div dcColor="wire-white-fixed" [translate]="'CLOSE'" i18n="@@CLOSE">Close</div>
                </button>
            }
        </div>
    </div>
}
